import Vue from 'vue'
import VueRouter from 'vue-router'
import MainLayout from '@/layouts/MainLayout.vue'
import {
	checkPermission
} from '@/utils/permission'
import {
	adminApi
} from '@/api/auth'

Vue.use(VueRouter)

// 基础路由
const routes = [{
		path: '/login',
		name: 'login',
		component: () => import('@/views/Login.vue')
	},
	{
		path: '/no-permission',
		name: 'noPermission',
		component: () => import('@/views/NoPermission.vue')
	}
]

// 动态路由
const dynamicRoutes = [{
	path: '/',
	component: MainLayout,
	children: []
}]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// 生成路由 
async function generateRoutes() {
	// 从后端获取菜单数据
	const response = await adminApi.getMenu()
	if (response.code === 1) {
		const menuList = response.data.menu
		// 生成路由配置
		const generatedRoutes = generateRouteConfig(menuList)

		// 更新动态路由
		dynamicRoutes[0].children = generatedRoutes

		// 动态添加路由
		router.addRoutes(dynamicRoutes)

		return true
	}
	return false
}

// 生成路由配置
function generateRouteConfig(menuList) {
	const routes = []

	// 手动添加所有菜单的路由
			const menuNames = ['home', 'inbound', 'production', 'outbound', 'finance', 'customer', 'user', 'role', 'permission', 'otherSettings', 'print', 'inspection', 'develop', 'gas', 'dilution', 'cylinderStatistics', 'addproduction', 'enterprise', 'department', 'unit', 'cylinder', 'ccOrderList', 'volume', 'certificate', 'contract', 'contractSettings', 'contractList']

	menuNames.forEach(name => {
		const route = {
			path: name === 'home' ? '' : name,
			name: name,
			component: () => import(`@/views/${name.charAt(0).toUpperCase() + name.slice(1)}.vue`)
		}

		routes.push(route)
	})

	return routes
}

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') {
			return Promise.reject(err)
		}
	})
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => {
		if (err.name !== 'NavigationDuplicated') {
			return Promise.reject(err)
		}
	})
}

router.beforeEach(async (to, from, next) => {
	// 检查是否登录
	const token = localStorage.getItem('token')
	const userinfo = localStorage.getItem('userinfo')
	console.log('路由守卫检查:', {
		to: to.name,
		toPath: to.path,
		token,
		hasUserinfo: !!userinfo
	})

	// 已登录访问登录页，跳转到首页
	if (to.name === 'login' && token) {
		console.log('已登录，跳转到首页')
		// 直接使用replace跳转，避免重定向循环
		next({
			path: '/',
			replace: true
		})
		return
	}

	// 未登录且访问非登录页面，跳转到登录页
	if (to.name !== 'login' && !token) {
		console.log('未登录，跳转到登录页')
		next({
			name: 'login'
		})
		return
	}

	// 已登录但用户信息不存在，清除登录状态并跳转到登录页
	if (to.name !== 'login' && token && !userinfo) {
		console.log('用户信息不存在，跳转到登录页')
		localStorage.removeItem('token')
		localStorage.removeItem('userinfo')
		next({
			name: 'login'
		})
		return
	}

	// 已登录且有用户信息，处理动态路由
	if (to.name !== 'login' && token && userinfo) {
		if (dynamicRoutes[0].children.length === 0) {
			// 生成动态路由
			try {
				const success = await generateRoutes()
				console.log('生成路由结果:', success)
				// 动态路由生成后，重新导航到目标路由
				// 确保路由已经添加完成

				return next(to.path === '/' ? '/' : to.path)
			} catch (error) {
				console.error('生成路由时发生错误:', error)
				// 发生错误时，不清除登录状态，继续尝试
				// 手动添加首页路由，确保至少可以访问首页
				if (dynamicRoutes[0].children.length === 0) {
					dynamicRoutes[0].children = [{
						path: '',
						name: 'home',
						component: () => import('@/views/Home.vue')
					}]
					router.addRoutes(dynamicRoutes)
				}
				// 重新导航到首页
				return next('/')
			}
		} else {
			// 动态路由已生成，直接放行
			console.log('动态路由已生成，放行')
			next()
		}
		return
	}

	// 其他情况，直接放行
	next()
})

export default router